import { render, staticRenderFns } from "./errorHandle.vue?vue&type=template&id=b20936a0"
import script from "./errorHandle.vue?vue&type=script&lang=js"
export * from "./errorHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports